// extracted by mini-css-extract-plugin
module.exports = {"section":"testimonial-module--section--2W4VF","image":"testimonial-module--image--18QY-"};